<template>

  <div class="rows">

    <div class="row" v-for="cantonnier in cantonniers.data" v-bind:key="cantonnier.id">
      <div class="col-xs-5">
        <span class="title-item">Nom, prénom</span>
        <span class="text-item">{{cantonnier.nom}}, {{cantonnier.prenom}}</span>
      </div>
      <div class="col-xs-5">
        <span class="title-item">Arrondissement de rattachement</span>
        <span class="text-item">
          {{ cantonnier.arrondissement_id | arrondissementName }}
        </span>
      </div>
      <div class="col-xs-2">
        <div class="actions">
          <a class="action-edit" v-on:click="$emit('edit', cantonnier)">
            <img src="../../../../static/img/edit-icon.svg">
          </a>
          <a class="action-delete right-separator" v-on:click="$emit('delete', cantonnier)">
            <img src="../../../../static/img/delete-icon.svg">
          </a>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  computed: {

    ...mapState([
      'cantonniers'
    ]),

  },
  mounted: function () {
    this.$store.dispatch('fetchCantonniersByVilleId')
  },
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// CantonniersList.vue?f68a4f64